import Swiper from 'swiper/bundle';
import initialiser from '../../utils/initialiser';

class CardCarousel {
  constructor(config) {
    const { el, settings } = config;

    this.container = el;
    this.swiperInstance = null;
    this.settings = settings;
    this.swiperRightMargin = 0;
    this.swiperBreakPoint = settings.mediaQuery;
    this.revalidateLazyImages = settings.revalidateLazyImages;
  }

  init = () => {
    this.initSwiper();

    window.addEventListener('resize', () => {
      this.handleRightMargin();
    });
  };

  initSwiper = () => {
    this.swiperInstance = new Swiper(this.container, this.settings);
    this.swiperInstance.on('slideChange', () => {
      if (this.revalidateLazyImages) this.revalidateLazyImages();
    });
    this.swiperInstance.appendSlide('<div class="swiper-slide c-card-carousel__slide--end"></div>');
    this.handleRightMargin();
  };

  handleRightMargin = () => {
    const winWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    if (winWidth <= this.swiperBreakPoint) {
      /* Remove Swiper */
      this.container.classList.add('is-swiper-disabled');
      this.swiperInstance.destroy(true, true);
      this.container.style.marginRight = 'auto'; /* reset margin */
    } else {
      /* Add Swiper */
      this.container.classList.remove('is-swiper-disabled');
      this.swiperRightMargin = ((winWidth
         - (this.container.offsetWidth - this.swiperRightMargin)) / 2)
         - (this.settings.spaceBetween * 3) - 4;
      /* extend carousel to take the full right side of the page */
      this.container.style.marginRight = `-${this.swiperRightMargin}px`;
      this.swiperInstance = new Swiper(this.container, this.settings);
    }
  };
}

export default (settings) => initialiser(settings, CardCarousel);
